<template>
    <div class="double-button btn btn__double-button">
        <div class="double-button--left double-button--pane">
            <slot name="left"/>
        </div>
        <div class="double-button--right double-button--pane">
            <div class="double-button--content">
                <slot name="right"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {},
    };
</script>
